import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { PrimaryActionButtonContainer } from '../../../../../../containers/shipment-configuration-widget/primary-action-button-container';

import style from './actionable-rate-card.module.less';

export const ActionButton = memo(({ disabled = false }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();

  return (
    <PrimaryActionButtonContainer
      buttonClassName={style['primary-action-button']}
      buttonContainerClassName={style['primary-action-button-container']}
      buttonLabelClassName={style['primary-action-button-label']}
      disabled={disabled}
      fulfillmentPlanId={fulfillmentPlanId}
    />
  );
});

ActionButton.propTypes = {
  disabled: PropTypes.bool,
};
